import Store from 'store/store'
import Worker from 'worker-loader!workers/landscape' // eslint-disable-line import/no-webpack-loader-syntax
import { Landscape, Colors, prng } from 'ffp-generate'

import Seed from 'controllers/landscape/seed'

/**
 * IMPORTANT
 * The single source of truth for the procgen part is the seed: every changes or
 * re-generation should be done by modifying the seed, this controller sole
 * purpose is therefore to listen to the seed and act accordingly.
 * SEE controllers/landscape/seed for more details
 */

let worker
const work = (props, seed) => window.Worker
  ? new Promise((resolve, reject) => {
    worker && worker.terminate()
    worker = new Worker()
    worker.onmessage = e => resolve(Landscape.from(props, e.data))
    worker.onerror = reject
    worker.postMessage({ ...props, seed })
  })
  : new Landscape(props)

async function handleSeedChange () {
  Store.landscape.isLoading.set(true)

  prng.seed = Seed.swatch
  const colors = Colors.swatch({ random: prng.random })
  colors[Seed.background].isBackground = true

  Store.landscape.colors.set(colors)

  prng.seed = Seed.abstraction
  Store.landscape.abstraction.set(await work({
    ...Store.landscape.props.get(),
    colors,
    background: colors && colors.find(c => c.isBackground)
  }, Seed.abstraction))

  Store.landscape.isLoading.set(false)
}

export default {
  register: function () {
    Store.landscape.seed.subscribe(handleSeedChange)
    handleSeedChange()
  }
}



// WEBPACK FOOTER //
// ./src/controllers/landscape/register.js